<template>

  <div class="product-add" v-loading="loading">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px" v-if="!loading">
      
      <el-form-item label="是否开启商家配送：">
        <el-radio-group v-model="form.is_open">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">开启</el-radio>
        </el-radio-group>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>

</template>

<script>
  import DistributionApi from '@/api/distribution.js';
  export default {
    components:{
     
    },
    data() {
      return {
        /*是否正在加载*/
        loading: true,
        /*form表单数据*/
        form: {
          is_open: 0,
        },

        /*是否打开图片选择*/
        isupload:false,
      };
    },
    created() {
      this.getParams()
    },

    methods: {

      /*获取配置数据*/
      getParams() {
        let self = this;
        DistributionApi.getSetting({}, true).then(res => {
            self.form = res.data.setting;
            self.loading=false;
          })
          .catch(error => {
            self.loading=false;
          });

      },


      /*提交*/
      onSubmit() {
        let self = this;
        let params = this.form;
        self.loading = true;
        DistributionApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '设置成功',
            type: 'success'
          });
        })
        .catch(error => {
          self.loading = false;
        });
      },
      //监听复选框选中
      handleCheckedGetLog(e) {

      },
    }

  };
</script>
<style>
  .tips {
    color: #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/views/plus/distribution/setting.vue